module.exports = __webpack_public_path__ + "media/customizations/rianoridge/logo-new-2aa9a20c437ac78358cf69b45a6d5e82.png";